/**
 * Demo privacy blur while owner is impersonating.
 * sessionStorage so it lasts the demo tab but clears when the tab closes.
 */

export const DEMO_PRIVACY_STORAGE_KEY = 'skylite_demo_privacy_blur';
export const DEMO_PRIVACY_BODY_CLASS = 'skylite-demo-privacy-on';
export const DEMO_PRIVACY_BLUR_CLASS = 'skylite-privacy-blur';

export function isDemoPrivacyBlurOn() {
  try {
    return sessionStorage.getItem(DEMO_PRIVACY_STORAGE_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function setDemoPrivacyBlur(on) {
  try {
    if (on) sessionStorage.setItem(DEMO_PRIVACY_STORAGE_KEY, '1');
    else sessionStorage.removeItem(DEMO_PRIVACY_STORAGE_KEY);
  } catch (_) {
    /* ignore */
  }
  applyDemoPrivacyBodyClass(on);
  return Boolean(on);
}

export function toggleDemoPrivacyBlur() {
  return setDemoPrivacyBlur(!isDemoPrivacyBlurOn());
}

export function applyDemoPrivacyBodyClass(force) {
  if (typeof document === 'undefined' || !document.body) return;
  const on = force != null ? Boolean(force) : isDemoPrivacyBlurOn();
  document.body.classList.toggle(DEMO_PRIVACY_BODY_CLASS, on);
}

/** CSS injected once for React shell (learning center has its own copy). */
export const DEMO_PRIVACY_CSS = `
body.skylite-demo-privacy-on .skylite-privacy-blur,
body.skylite-demo-privacy-on [data-skylite-privacy="blur"] {
  filter: blur(8px) !important;
  user-select: none !important;
  transition: filter 0.15s ease;
}
body.skylite-demo-privacy-on .skylite-privacy-blur * {
  user-select: none !important;
}
`;
